import axios from 'axios';
import { useQuery } from 'react-query';
import { toast } from 'react-toastify';

export const useFetchPostData = () => {
  const fetchPost = async () => {
    const response = await axios.get('https://strapi4.cloodo.com/api/posts', {
      params: {
        'filters[$and][0][user_profile][name][$eq]': 'printcart',
        'pagination[pageSize]': 3,
        'sort[0]': 'publishedAt:desc',
      },
    });
    return response?.data?.data;
  };

  return useQuery('post-data-printcart-publishedAt-3', fetchPost);
};

export const useFetchServiceData = (currentPage) => {
  const fetchServiceData = async () => {
    try {
      const response = await axios.get('https://data2.cloodo.com/api/services', {
        params: {
          populate: '*',
          'filters[$and][0][users_permissions_user][email][$eq]':
            'admin@printcart.com',
          'pagination[page]': currentPage,
          'pagination[pageSize]': 18,
          'filters[$and][1][publishedAt][$notNull]': true,
          sort: 'createdAt:DESC',
          time: Date.now(),
        },
      });
      return response?.data;
    } catch (error) {
      toast.error('Something went wrong');
    }
  };
  return useQuery(['service-data', currentPage], fetchServiceData);
};

export const useFetchTutorialData = (currentPage) => {
  const fetchTutorialData = async () => {
    try {
      const response = await axios.get('https://strapi4.cloodo.com/api/posts', {
        params: {
          'filters[$and][0][tags][name][$eq]': 'printcart',
          'pagination[pageSize]': 6,
          'fields[0]': 'alias',
          'fields[1]': 'title',
          'fields[2]': 'createdAt',
          'fields[3]': 'short_intro',
          'populate[user_profile]': '*',
          'populate[tags][fields][0]': 'name',
          'populate[tags][fields][1]': 'alias',
          'populate[banner][fields][0]': 'formats',
          'pagination[page]': currentPage,
          'sort[0]': 'publishedAt:desc',
        },
      });
      return response?.data;
    } catch (error) {
      toast.error('Something went wrong');
    }
  };
  return useQuery(['tutorial-data', currentPage], fetchTutorialData);
};

export const useFetchWixData = () => {
  const fetchPost = async () => {
    try {
      const response = await axios.get('https://strapi4.cloodo.com/api/projects', {
        params: {
          'filters[$and][0][agency][id][$eq]': 568427,
          'pagination[pageSize]': 1,
          'filters[$and][0][name][$eq]': 'Printcart Wix Intergration',
        },
      });
      return response?.data?.data;
    } catch (error) {
      toast.error('Something went wrong');
    }
  };

  return useQuery('post-Wix-data', fetchPost);
};

export const useFetchShopifyData = () => {
  const fetchPost = async () => {
    try {
      const response = await axios.get('https://strapi4.cloodo.com/api/projects', {
        params: {
          'filters[$and][0][id][$eq]': 590588,
        },
      });
      return response?.data?.data;
    } catch (error) {
      toast.error('Something went wrong');
    }
  };

  return useQuery('post-Shopify-data', fetchPost);
};

export const useFetchWordpressData = () => {
  const fetchPost = async () => {
    try {
      const response = await axios.get('https://strapi4.cloodo.com/api/projects', {
        params: {
          'filters[$and][0][id][$eq]': 590589,
        },
      });
      return response?.data?.data;
    } catch (error) {
      toast.error('Something went wrong');
    }
  };

  return useQuery('post-Wordpress-data', fetchPost);
};
